import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'replaceCurrency'})
export class ReplaceCurrencyPipe implements PipeTransform {
  transform(value: any): string {
    return value && typeof value == "string" && value.replace(/[^–]+\s?–\s?/g, '');
  }
}
